import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { installAppSessionFetchTransport } from './utils/appSessionFetchTransport';
import logger from './utils/logger';

installAppSessionFetchTransport();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch((error) => {
      logger.warn('[PWA] Service Worker registration failed', error);
    });
  }, { once: true });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
